import React, { ReactNode } from 'react';
const ArrowRightIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/EinsteinArrowRight.svg';

import * as S from './styles';

type InfoProps = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  adress?: string;
  local?: string;
  link?: string;
};
const Info: React.FC<InfoProps> = ({ icon, title, subtitle, adress, local, link }) => {
  return (
    <S.Container>
      <div className="icon">{icon}</div>
      <div className="info">
        {title && !subtitle ? (
          <>
            <p className="subtitle">{title}</p>
          </>
        ) : (
          <>
            <h5 className="title">{title}</h5>
            <p className="subtitle">{subtitle}</p>
          </>
        )}
        {!!adress && <p className="aditional">{adress}</p>}
        {!!local && <p className="aditional">{local}</p>}
        {!!link && (
          <a className="link" href={link} target="_blank" rel="noreferrer">
            Ir para consulta <img src={ArrowRightIcon} alt="" />
          </a>
        )}
      </div>
    </S.Container>
  );
};

export default Info;
